<!--
================================================
Un composant qui affiche la liste détaillée des timerecords par période.

Est un "fork" de TaskTimerecordsListComp, j'ai fait "un fork" car le composant TaskTimerecordsListComp charge ses tr tout seul (pas compatible avec le filtrage).

Url d'accès : http://localhost:8080/fr/rpvtest-inc/reports/detailed/start=/end=/cltArchShow=/

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="TimerecordsDetailedListComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <div class="loaderContainer" v-if="loadingData">
      <spinner-loader-comp v-bind:loading-txt="$t('récupérationDesDonnées')+'...'"></spinner-loader-comp>
    </div>
    <div id="loadedContent" v-else>

      <div class="resultCont" v-if="countResults > 0">
        <table class="appBloc table  is-fullwidth" v-if="value[0]!=null"
               v-for="(value, name, index) in timerecordsOfPeriod"
               v-bind:timerecord="value" :key="'lineDay-' +name">

          <thead>

          <!-- NOTE : cette partie .lineDay est dupliquée de TaskTimerecordListComp, pour le moment n'a pas été mutualisée, car elle peut possiblement évoluer differement -->
          <tr class="has-text-left lineDay ">
            <th colspan="6">
              <font-awesome-icon :icon="['far', 'calendar-alt']" class="icon"/>

              {{ formatDateWithDayName(name, locale) }}

              <task-day-duration-comp v-bind:dayRef="value[0].timeIn"
                                      v-bind:timerecords="value"></task-day-duration-comp>

            </th>
          </tr>
          </thead>

          <tbody>


          <!-- on boucle sur tous les jours (groupants les tr) de la période-->

          <task-timerecord-table-line-comp
              v-bind:read-only="true"
              v-for="(item,index2) in value"
              class="dayDetail"
              v-bind:class="'day_'+index+'-line_'+index2" v-bind:show-user="true"
              v-bind:timerecord="item" v-bind:key="'day'+index+'-line_'+index2"
          >

            {{ index2 }}
            <td class="day">
              <!--                    {{index}}-->
              {{ item }}
            </td>
            <!--                    v-if="isSameDay(value.timeIn, value.timeIn)"-->
            <!--                </tr>-->
          </task-timerecord-table-line-comp>

          </tbody>
          <!--             </table>-->

        </table>
      </div>
      <div v-else class="noResultCount">
        {{ $t('aucunResultatPourLaPeriode') }}
      </div>

    </div>

  </div>


  <!--    https://www.npmjs.com/package/v-click-outside-->
  <!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import TimeMixin from "../../mixins/TimeMixin.js";
import SentryMixin from "../../mixins/SentryMixin.js";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import TaskDayDurationComp from "../TaskDayDurationComp";
import TimerecordReportTableLineComp from "./TimerecordReportTableLineComp";
import TaskTimerecordTableLineComp from "@/components/TaskTimerecordTableLineComp";
import SpinnerLoaderComp from "@/components/SpinnerLoaderComp";
import _ from "lodash";

export default {
  name: 'TimerecordsDetailedListComp',
  components: {SpinnerLoaderComp, TaskTimerecordTableLineComp, TimerecordReportTableLineComp, TaskDayDurationComp},
  //utile dans vue dev tool
  mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TimeMixin],
  // components: {},

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    timerecordsOfPeriod: Object
  },
  data: function () {
    return {
      locale: this.$route.params.locale,
      loadingData: false,// bool indique si une requête de récupération de données est en cours
      hasResult: false, // bool vaut true si this.timerecordsOfPeriod a au moins 1 résultat
      // =================================================================
    }
  },

  computed: {

    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    // le nombre de résultats (timerecrods) dans this.timerecordsOfPeriods
    countResults: function () {
      let count = 0
      _.forEach(this.timerecordsOfPeriod, function (value, key) {
        if (!_.isEmpty(value)) {
          count++
        }
      });
      return count
    }

  },
  // watch: {
  //     // à chaque fois que la prop computed change, cette fonction s'exécutera
  //     user: function () {
  //     }
  // },


  methods: {
  },

  watch: {
    hasResult: function () { // vaut true si timerecordsOfPeriod à au moins 1 résultat
      // get: function (){


      // return true
      // },
    }

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

    // this.countResults()
    /*
   * Event report_view_fetching_data, pour affichage du loader
   */
    this.$root.$on('report_view_fetching_data', (isLoading) => {
      isLoading ? this.loadingData = true : this.loadingData = false;
    })

  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

#TimerecordsDetailedListComp {
  padding-top: 1rem;


  .lineDay {
    // note : ce style est redondant avec .lineDay dans TaskTimerecordlistComp
    background: #f9f9f9;
    border: solid 1px #eeefef;

    th {
      color: $brandFourth;
    }
  }

  .loaderContainer {
    margin-bottom: 10rem;
  }

  .noResultCount {
    margin: 1rem auto;
    .icon {
      display: block;
      margin: 1rem auto;
      font-size: 4rem;
      color: #ccc;
    }
  }


  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {
    .lineDay {
      background: $darkBg2;
      border-color: $darkTableBorder;

      th {
        color: $darkLightBlue !important;

        .icon {
          color: #79a0c3
        }
      }
    }

    .loaderContainer {
      color: $darkTxt;
    }

    .noResultCount {
      color: $darkTxt;
    }
  }


}
</style>
